<script>
  import pedidoServico from '../servico';
  import pessoaServico from '~modulos/pessoa/servico';

  import formatarData from '~js/formatar-data';
  import converterMoeda from '~js/converter-moeda';
  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';

  import Dados from './compartilhado/FormPedidoDados.vue';
  import Itens from './compartilhado/FormPedidoItens.vue';
  import DadosBancarios from './compartilhado/FormDadosBancarios.vue';
  import AdicionarArquivos from '~componentes/FormAdicionarArquivos.vue';
  import Radio from '~componentes/Radio.vue';
  import { checkbox } from 'vue-strap';
  
  export default {
    components: { Dados, Itens, DadosBancarios, AdicionarArquivos, checkbox, Radio },
    data() {
      return {
        mostrarFormulario: false,
        pedido: {},
        carregando: true,
        configuracao: this.$storage.configuracao(),
        usuario: this.$storage.usuario(),
        dadosBancarios: [],
        arquivos: [],
      }
    },
    mounted() {
      this.$root.botaoAcaoTexto = 'Nova';
      this.$root.botaoAcaoIcon = 'fa-plus';
      this.$root.botaoAcaoLink = 'ROTA';
    },
    methods: {
      formatarDadosPedido() {
        if (this.pedido.dataPedido) {
          this.pedido.dataPedido = formatarData.paraData(this.pedido.dataPedido);
        }

        this.pedido.dataEntrega = moment(new Date()).format('DD/MM/YYYY');
        this.pedido.dataNotaFiscal = '';
        this.pedido.valorFrete = converterMoeda.paraReal(this.pedido.valorFrete);
        this.pedido.descontoPedido = converterMoeda.paraReal(this.pedido.descontoPedido);

        for(var i = 0; i< this.pedido.itensPedidoCompra.length; i++) {
          this.pedido.itensPedidoCompra[i].quantidadeRecebida = converterMoeda.paraReal(this.pedido.itensPedidoCompra[i].quantidadeRecebida || 0);
          this.pedido.itensPedidoCompra[i].quantidadeCancelada = converterMoeda.paraReal(this.pedido.itensPedidoCompra[i].quantidadeCancelada || 0);
          this.pedido.itensPedidoCompra[i].valorUnitarioEntregue = converterMoeda.paraReal(this.pedido.itensPedidoCompra[i].valorUnitarioEntregue || 0); 
        }
      },
      salvar() {
        $('#salvar').button('loading');
        
        this.$refs.dados
          .validar()
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados"]').tab('show');
              throw new Error("validacao");
            }

            return valido;
          })
          .then(this.validarAnexosNF)
          .then(this.validarAnexosBoleto)
          .then(this.$refs.dadosBancarios.validar)
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-bancarios"]').tab('show');
              throw new Error("validacao");
            }

            return valido;
          })
          .then(this.$refs.itens.validarItens)
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-itens"]').tab('show');

              this.$swal(
              '',
              'É necessário fazer o recebimento de pelo menos um item ',
              'info'
              );

              throw new Error('validacao');
            }

            return valido;
          })
          .then(this.validarArquivosObrigatorio)
          .then(this.validarArquivos)
          .then(valido => {
            if (!valido) {
                $('#tabs a[href="#tab-adicionar-arquivos"]').tab('show');

                this.$swal(
                    '',
                    'É necessário anexar pelo menos um arquivo ',
                    'info'
                );

                throw new Error('validacao');
            }

            return valido;
          })
          .then(this.enviar)
          .then(id => {

            this.$swal(
              '',
              'Pedido recebido com sucesso e solicitação de pagamento pessoa jurídica criada.',
              'info'
            );

            this.$router.push('/pedido');
          })
          .catch(erro => {
            $('#salvar').button('reset');
            this.$mensagemErro(erro, 'Erro ao salvar o pagamento do pedido de compra.');
          });
        },
        async validarArquivosObrigatorio() {
            if (!this.configuracao.usarArquivosSolicitacaoPagamentos)
                return true;

            if ((this.configuracao.solicitacaoPJAnexarNF == false) && (this.configuracao.solicitacaoPJAnexarBoleto == false))
                return true;

            var quantidadeArquivo = 0;
            var quantidadeMinimaArquivos = 0;

            if (this.pedido.solicitacaoPJAnexouNF == 'true')
                quantidadeMinimaArquivos += 1;

            if (this.pedido.solicitacaoPJAnexouBoleto == 'true')
                quantidadeMinimaArquivos += 1;

            for (var i = 0; i < this.$refs.adicionarArquivos.arquivos.length; i++) {
                if (this.$refs.adicionarArquivos.arquivos[i]) {
                    quantidadeArquivo += 1;
                }
            }

            if (quantidadeArquivo < quantidadeMinimaArquivos) {
                $('#tabs a[href="#tab-adicionar-arquivos"]').tab('show');

                this.$swal(
                    '',
                    'É necessário anexar pelo menos ' + (quantidadeMinimaArquivos - quantidadeArquivo) + ' arquivo(s) ',
                    'info'
                );

                $('#salvar').button('reset');
                throw new Error('validacao');
            }

            return true;
        },
        validarAnexosNF(valido) {
            if (!valido) throw new Error("validacao com erro");

            if (!this.configuracao.solicitacaoPJAnexarNF)
                return true;

            let msgErro = "";
            let validou = true;

            if (!((this.pedido.solicitacaoPJAnexouNF == 'true') || (this.pedido.solicitacaoPJAnexouNF == 'false'))) {
                validou = false;
            }

            if (this.pedido.solicitacaoPJAnexouNF == 'false' && !this.pedido.solicitacaoPJJustificouNF) {
                validou = false;
            }

            if (!validou) msgErro = `É necessário informar se anexou a Nota Fiscal e, em caso negativo, selecionar que está ciente de que não anexou o documento.`

            if (msgErro) {
                $('#tabs a[href="#tab-adicionar-arquivos"]').tab('show');

                this.$swal(
                    '',
                    msgErro,
                    'info'
                );

                throw new Error("validacao");
                return false;
            }
            else return this.$validator.validateAll();
        },
        validarAnexosBoleto(valido) {
            if (!valido) throw new Error("validacao com erro");

            if (!this.configuracao.solicitacaoPJAnexarBoleto)
                return true;

            if (this.pedido.formaPagamento !== 3)
                return true;

            let msgErro = "";
            let validou = true;

            if (!((this.pedido.solicitacaoPJAnexouBoleto == 'true') || (this.pedido.solicitacaoPJAnexouBoleto == 'false'))) {
                validou = false;
            }


            /*if (this.pedido.solicitacaoPJAnexouBoleto == 'false' && !this.pedido.solicitacaoPJJustificouBoleto) {
                validou = false;
            }*/

            if (!validou) msgErro = `É necessário informar se anexou o Boleto.`

            if (msgErro) {
                $('#tabs a[href="#tab-adicionar-arquivos"]').tab('show');

                this.$swal(
                    '',
                    msgErro,
                    'info'
                );

                throw new Error("validacao");
                return false;
            }
            else return valido;
        },
      validarArquivos() {
        if (this.configuracao.usarArquivosSolicitacaoPagamentos) {
          var existeArquivo = false;

          for (var i = 0; i < this.$refs.adicionarArquivos.arquivos.length; i++) {
            if (this.$refs.adicionarArquivos.arquivos[i]) {
              existeArquivo = true;
              break;
            }
          }

          return existeArquivo;
        }
        else
          return true;  
      },
      enviar(valido) {
        if (!valido) throw new Error("validacao com erro");
        
        const copiaPedido = JSON.parse(JSON.stringify(this.pedido));

        return pedidoServico.adicionar(copiaPedido, this.$refs.adicionarArquivos.arquivos);
      },
      carregar: function (id) {
        this.carregando = true;

        pedidoServico
          .obterPorId(id)
          .then(pedido => {
            this.carregando = false;
            this.pedido = pedido;
            this.formatarDadosPedido();

            this.$root.tituloDaPagina = `Pedido de Compra/ Ordem de Serviço Nº: ${this.pedido.numeroPedidoCompra || ''} | Sol. web:  ${this.pedido.idSolicitacaoCompra|| ''} - Recebimento`;

            this.$set(this, 'mostrarFormulario', true);
          })
          .then(() => {
            return this.carregarDadosBancarios(this.pedido.cpfCnpj);
          })
          .catch(erro => {
            this.carregando = false;

            if (erro.status === 422) { 
              this.$swal('', erro.body.message, 'error');
            } else{
              this.$swal('', 'Ocorreu um erro ao exibir recebimento do pedido, tente novamente.', 'error');
            }

            this.$router.push('/pedido');
          });
      },
      resetarComponente() {
        Object.assign(this.$data, this.$options.data.apply(this));
      },
      limparDadoBancario() {
        if (this.pedido.formaPagamento !== 0) {
          this.pedido.banco = '';
          this.pedido.agencia = '';
          this.pedido.contaCorrente = '';
          this.pedido.tipoConta = '';
        }
      },
      carregarDadosBancarios(cpf) {
        return pessoaServico
          .dadosBancarios(cpf)
          .then(dadosBancarios => {
            this.dadosBancarios = dadosBancarios;
          })
      },
    },
    created() {
     if (this.$route.params.id) {
       this.carregar(this.$route.params.idCript);
     } else {
       this.$router.push('/pedido');
     }
    },
    watch: {
      'pedido.formaPagamento': 'limparDadoBancario',
    }
  }
</script>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao">
    <div class="ibox float-e-margins" v-if="carregando">
      <div class="ibox-content">
        <p class="text-center">
          <i class='fa fa-spinner fa-pulse'></i> Carregando...
        </p>
      </div>
    </div>
    <form @submit.prevent="validar">
      <div class="row" v-if="mostrarFormulario">
        <div class="col-xs-12">
          <div class="tabs-container" v-show="!carregando" id="tabs">

            <ul class="nav nav-tabs">
              <li class="active">
                <a data-toggle="tab"
                   href="#tab-dados">
                  Dados
                </a>
              </li>
              <li :class="{'disabled': pedido.formaPagamento !== 0}">
                <a @click.prevent=""
                   :data-toggle="pedido.formaPagamento === 0 ? 'tab' : ''"
                   href="#tab-dados-bancarios">
                  Dados bancários
                </a>
              </li>
              <li>
                <a data-toggle="tab"
                   href="#tab-itens">
                  Itens
                </a>
              </li>
              <li v-if="configuracao.usarArquivosSolicitacaoPagamentos">
                <a data-toggle="tab"
                   href="#tab-adicionar-arquivos">
                  Adicionar arquivos
                </a>
              </li>

            </ul>
            <div class="tab-content">

              <div id="tab-dados" class="tab-pane active">
                <div class="panel-body">
                  <dados ref="dados"
                         :pedido="pedido">
                  </dados>
                </div>
              </div>

              <div id="tab-dados-bancarios" class="tab-pane">
                <div class="panel-body">
                  <dados-bancarios ref="dadosBancarios"
                                   :pedido="pedido"
                                   :edicao="!!$route.params.id"
                                   :dadosBancarios="dadosBancarios">
                  </dados-bancarios>
                </div>
              </div>

              <div id="tab-itens" class="tab-pane">
                <div class="panel-body">
                  <itens ref="itens"
                         :pedido="pedido">
                  </itens>
                </div>
              </div>

              <div id="tab-adicionar-arquivos" class="tab-pane">
                  <div class="panel-body">
                      <adicionar-arquivos ref="adicionarArquivos">
                      </adicionar-arquivos>

                      <div class="hr-line-dashed" v-if="configuracao.solicitacaoPJAnexarNF || configuracao.solicitacaoPJAnexarBoleto"></div>

                      <h3 class="m-t-none m-b margin-top-5" v-if="configuracao.solicitacaoPJAnexarNF || configuracao.solicitacaoPJAnexarBoleto">Arquivos anexados:</h3>

                      <div class="hr-line-dashed" v-if="configuracao.solicitacaoPJAnexarNF || configuracao.solicitacaoPJAnexarBoleto"></div>

                      <div class="row" v-if="configuracao.solicitacaoPJAnexarNF">
                          <div class="col-sm-12">
                              <div class="form-group required">
                                  <label class="control-label" for="anexouNF" style="padding-top: 11px;">Anexou a nota fiscal?</label>
                              </div>
                          </div>
                      </div>

                      <div class="row" v-if="configuracao.solicitacaoPJAnexarNF">
                        <div class="col-sm-2">
                          <div class="form-group required">
                            <radio v-model="pedido.solicitacaoPJAnexouNF"
                                   selected-value="true"
                                   type="success"
                                   :inline="true"
                                   class="margin-right-10"
                                   @change="pedido.solicitacaoPJJustificouNF = null"
                                   :class="[true ? '' : 'radioLeft']">
                              Sim
                            </radio>
                            <radio v-model="pedido.solicitacaoPJAnexouNF"
                                   selected-value="false"
                                   data-vv-name="anexouNF"
                                   type="success"
                                   :inline="true">
                              N&atilde;o
                            </radio>
                          </div>
                        </div>

                        <div class="col-sm-3" v-if="pedido.solicitacaoPJAnexouNF == 'false'" style="margin-left: -90px;">
                          <checkbox v-model="pedido.solicitacaoPJJustificouNF" :true-value="true" type="success" required>
                            <small>Me comprometo a inserir a nota fiscal no Sistema Manager após o recebimento do produto.</small>
                          </checkbox>
                        </div>

                        <div class="col-sm-7" v-if="pedido.solicitacaoPJAnexouNF == 'false'">
                          <div class="form-group required" :class="{'has-error': errors.has('justificativa')}">
                            <label class="control-label" for="justificativa">Justificar o motivo de não ter inserido a nota fiscal</label>

                            <input type="text"
                                   class="form-control"
                                   id="justificativa"
                                   v-model="pedido.solicitacaoPJJustificativaNF"
                                   data-vv-name="justificativa"
                                   data-vv-as="Justificativa"
                                   v-validate="'required'">

                            <p class="text-danger" v-show="errors.has('justificativa')">{{ errors.first('justificativa') }}</p>
                          </div>
                        </div>
                      </div>

                      <div class="row" v-if="configuracao.solicitacaoPJAnexarBoleto && pedido.formaPagamento === 3">
                          <div class="col-sm-12">
                              <div class="form-group required">
                                  <label class="control-label" for="anexouBoleto" style="padding-top: 11px;">Anexou o boleto dentro do vencimento?</label>
                              </div>
                          </div>
                      </div>

                      <div class="row" v-if="configuracao.solicitacaoPJAnexarBoleto && pedido.formaPagamento === 3">
                          <div class="col-sm-2">
                              <div class="form-group" :class="{'required': true }">
                                  <radio v-model="pedido.solicitacaoPJAnexouBoleto"
                                         selected-value="true"
                                         type="success"
                                         :inline="true"
                                         class="margin-right-10"
                                         @change="pedido.solicitacaoPJJustificouBoleto = null"
                                         :class="[true ? '' : 'radioLeft']">
                                      Sim
                                  </radio>
                                  <radio v-model="pedido.solicitacaoPJAnexouBoleto"
                                         selected-value="false"
                                         data-vv-name="anexouBoleto"
                                         type="success"
                                         :inline="true">
                                      N&atilde;o
                                  </radio>
                              </div>
                          </div>

                          <div class="col-sm-10" v-if="false" style="margin-left: -90px;">
                              <checkbox v-model="pedido.solicitacaoPJJustificouBoleto" :true-value="true" type="success" required>
                                  <small>Texto que compromete enviar Boleto</small>
                              </checkbox>
                          </div>
                      </div>

                      <div class="hr-line-dashed margin-top-20" v-if="configuracao.solicitacaoPJAnexarNF || configuracao.solicitacaoPJAnexarBoleto"></div>
                  </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <router-link class="btn btn-default"
                         :to="{ name: 'pedido' }"
                         v-show="!mostrarFormulario || !!$route.params.id"
                         active-class="">
              <i class="fa fa-arrow-left"></i>
              Voltar
            </router-link>

            <button id="salvar"
                    type="button"
                    class="btn btn-primary"
                    @click="salvar"
                    v-show="mostrarFormulario"
                    data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
              <i class="fa fa-save"></i>
              Salvar
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/pedido/componentes/PedidoRecebimentoForm.vue